import { Page } from "../enums/Page";
import { css } from "../helpers/webComponents";
import { htmlArray } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { LeaderboardService } from "../services/LeaderboardService";

const styles: string = css`
    :host {
        display: block;
        font-family: Arial, sans-serif;
        max-width: 600px;
        margin: auto;
    }

    .leaderboard-container {
        background: #f5f5f5;
        padding: 20px;
        border-radius: 10px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        text-align: center;
    }

    h2 {
        font-size: 28px; /* Groter lettertype voor 'Klassement' */
        color: #333;
        font-weight: bold;
        margin-bottom: 15px;
    }

    .leaderboard {
        width: 100%;
        border-collapse: collapse;
        border-radius: 10px;
        overflow: hidden;
    }

    .leaderboard th, .leaderboard td {
        padding: 12px;
        text-align: left;
        border-bottom: 1px solid #ccc;
        color: white;
    }

    .leaderboard th {
        background-color: #52478b;
        color: white;
    }

    .leaderboard tr:nth-child(odd) {
        background-color: #555; /* Donkergrijs voor rijen 1 en 3 */
    }

    .leaderboard tr:nth-child(even) {
        background-color: #d3d3d3; /* Lichtgrijs voor rijen 2 en 4 */
    }

    .button-container {
        display: flex;
        justify-content: flex-start; /* Terug-knop links */
        gap: 10px;
        margin-top: 20px;
    }

    button {
        background: #52478b;
        color: white;
        border: none;
        padding: 10px 20px;
        cursor: pointer;
        font-size: 16px;
        border-radius: 5px;
    }

    button:hover {
        background: #332c57;
    }
`;

export class LeaderboardComponent extends HTMLElement {
    private _gameEventService: GameEventService = new GameEventService();
    private leaderboardService: LeaderboardService = new LeaderboardService();
    private scores: { username: string; total_score: number; items_collected: number; ending: string }[] = [];

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    public async connectedCallback(): Promise<void> {
        console.log("LeaderboardComponent connected. Fetching scores...");
        await this.fetchScores();
    }

    private async fetchScores(): Promise<void> {
        try {
            console.log("Fetching leaderboard data...");
            this.scores = await this.leaderboardService.fetchLeaderboard();
            this.scores.sort((a, b) => b.total_score - a.total_score);
            this.render();
        }
        catch (error) {
            console.error("Error fetching leaderboard data:", error);
        }
    }

    private render(): void {
        if (!this.shadowRoot) return;

        const source: string = localStorage.getItem("leaderboardSource") || "leaderboardButton";

        const tableRows: string = this.scores.map((entry, index) => `
            <tr>
                <td>${index + 1}</td>
                <td>${entry.username}</td>
                <td>${entry.total_score}</td>
                <td>${entry.items_collected}</td>
                <td>${entry.ending}</td>
            </tr>
        `).join("");

        let buttonsHTML: string = "<button id=\"backButton\">Terug</button>";
        if (source === "resultComponent") {
            buttonsHTML += "<button id=\"replayButton\">Opnieuw spelen</button>";
        }

        const elements: HTMLElement[] = htmlArray`
            <style>${styles}</style>
            <div class="leaderboard-container">
                <h2>Klassement top 10</h2>
                <table class="leaderboard">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Naam</th>
                            <th>Score</th>
                            <th>Items</th>
                            <th>Einde</th>
                        </tr>
                    </thead>
                    <tbody>${tableRows}</tbody>
                </table>
                <div class="button-container">${buttonsHTML}</div>
            </div>
        `;

        this.shadowRoot.innerHTML = "";
        this.shadowRoot.append(...elements);

        const backButton: HTMLElement = this.shadowRoot.querySelector("#backButton") as HTMLElement;
        backButton.addEventListener("click", () => {
            if (source === "resultComponent") {
                localStorage.removeItem("leaderboardSource");
                this._gameEventService.switchPage(Page.Result);
            }
            else {
                this._gameEventService.switchPage(Page.Canvas);
            }
        });

        if (source === "resultComponent") {
            const replayButton: HTMLElement = this.shadowRoot.querySelector("#replayButton") as HTMLElement;
            replayButton.addEventListener("click", () => {
                localStorage.removeItem("leaderboardSource");
                this._gameEventService.switchPage(Page.Canvas);
            });
        }
    }
}
